module.exports = __webpack_public_path__ + "static/media/bluepicture.01dcbd7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/bluepicture.png
// module id = 1143
// module chunks = 0